import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ellanmobility/src/app/products/multi-vendor/components/MultiVendorContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ellanmobility/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ellanmobility/src/components/Header.tsx");
